import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type SettingsSection =
  | 'profile'
  | 'general'
  | 'company'
  | 'users'
  | 'connections'
  | 'payments'
  | 'agents'
  | 'alerts';

@Injectable({
  providedIn: 'root'
})
export class SettingsStateService {
  private activeSettingsSectionSubject = new BehaviorSubject<SettingsSection>('general');
  
  public activeSettingsSection$ = this.activeSettingsSectionSubject.asObservable();

  constructor() {}

  setActiveSection(section: SettingsSection): void {
    this.activeSettingsSectionSubject.next(section);
  }

  getActiveSection(): SettingsSection {
    return this.activeSettingsSectionSubject.value;
  }
}
